import React, { useState, useEffect } from "react";
import DataServiceSQL from "../../DataService/DataServiceSQL";
import DeviceFunctionsGetter from '../../Controller/getSQLDeviceFunctions.js';
import { Row, Col } from 'reactstrap';
import { withStyles } from '@material-ui/core';
import * as Constants from '../../Pages/Constants';
import {FormattedMessage} from 'react-intl';

const Device = props => {

  const [currentDevice, setCurrentDevice] = useState({id_device: props.id_device, sn: "", FK_structure: 0}); // TEMP : sure ?

  const [submitted, setsubmitted] = useState(false);
  const [message, setmessage] = useState("");

  useEffect(() => {
    getDevice(props.id_device, props.structure_Id);
  }, 
  //eslint-disable-next-line
  [props.id_device]);

  const getDevice = async (id_device, structure_Id) => {
    let local_device = [];
    local_device = await DeviceFunctionsGetter.get_device_by_criteria("identifier", id_device);

    if (local_device !== "none"){
      local_device = local_device[0]
      setCurrentDevice(local_device)
    }
  };

  const handleInputChange = event => {
    const { name, value } = event.target;
    setCurrentDevice({ ...currentDevice, [name]: value });
  };

  const updateDevice = () => {

    let gateway_data = {
      resourceType: "Device",
      type: "Sensor",
      name: currentDevice.nickname
    }
    DataServiceSQL.updateDeviceReq_fhir(currentDevice.id_device, gateway_data)
      .then(response => {
        setmessage(<FormattedMessage id="message.success" defaultMessage="Success !" />);
        setsubmitted(true);
      })
      .catch(e => {
        setmessage(<FormattedMessage id="message.error.device.up" defaultMessage="Oups, did not work... (err_code device_up)" />);
        setsubmitted(true);
      });
  };

  const { classes } = props;

  return (
    <div className={classes.popup_background}>
      <div style={{ height: "100%", display: "flex", flexDirection: "column", justifyContent: "center"}}>
        <div className="submit-form">
          {(submitted) ? (
            <div>
              <center>
                <h4>{message}</h4>
                <button onClick={props.closeAfterEdit} className="btn btn-success">
                  <FormattedMessage id="button.close" defaultMessage="Close" />
                </button>
              </center>
            </div>
          ) 
          : 
          (
            <div>
              <center>
                <div>
                  <Row className="justify-content-md-end" style = {{ paddingBottom: "10px" }}>
                    <Col style={{ fontWeight: "bold", fontSize:"2.2em" }}>
                        <FormattedMessage id="device.edit" defaultMessage="Edit device" />
                    </Col>
                  </Row>
                </div>
                <br/>                                                                   
                <div className="form-group">
                  <label htmlFor="nickname">
                    <FormattedMessage id="device.nickname" defaultMessage="Nickname" />
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="nickname"
                    name="nickname"
                    value={currentDevice.nickname}
                    onChange={handleInputChange}
                  />
                </div>                             
                <br/>
                <button onClick={props.cancelPopup} className="btn btn-danger">
                  <FormattedMessage id="button.cancel" defaultMessage="Cancel" />
                </button>
                <b>&emsp;</b>
                <button onClick={updateDevice} className="btn btn-success">
                  <FormattedMessage id="button.submit" defaultMessage="Submit" />
                </button>
              </center>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default withStyles(Constants.styles)(Device);
